import { Component, OnInit, inject } from '@angular/core';
import { PostTradeService } from '../../post-trade.service';

@Component({
  selector: 'app-aml-monitor-dashboard',
  templateUrl: './aml-monitor-dashboard.component.html',
  styleUrls: ['./aml-monitor-dashboard.component.scss'],
  standalone: false,
})
export class AmlMonitorDashboardComponent implements OnInit {
  private ptSvc = inject(PostTradeService);


  ngOnInit(): void {
    this.ptSvc.loading.set(true);
    setTimeout(() => {
      this.ptSvc.loading.set(false);
    }, 1000);
  }
}
